import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { company } from './content';
export default function ContactForm() {
  const [params] = useSearchParams();
  const form = useRef(null);
  const busy = useRef(false);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);
  async function submit(event) {
    event.preventDefault();
    if (busy.current) return;
    const values = new FormData(form.current);
    if (values.get('website')) {
      setStatus('error');
      setError('Please call or email us directly.');
      return;
    }
    const required = ['first_name', 'last_name', 'email', 'subject', 'message'];
    if (required.some(key => !String(values.get(key) || '').trim())) {
      setStatus('error');
      setError('Please complete all required fields.');
      return;
    }
    busy.current = true;
    setStatus('sending');
    setError('');
    try {
      const response = await fetch('/api/enquiry.php', {
        method: 'POST',
        body: values,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error(`Enquiry service returned ${response.status}`);
      form.current.reset();
      setStatus('success');
    } catch {
      setStatus('error');
      setError('Your message could not be sent. Your text is still here. Please email info@anbelat.com or call 0935404127.');
    } finally {
      busy.current = false;
    }
  }
  return <form ref={form} onSubmit={submit} method="post" action="/api/enquiry.php" className="enquiry-form" aria-label="Project enquiry">
    <fieldset disabled={!ready}>
    <h2>Tell us about your project</h2><p>Fields marked * are required. Please leave out confidential documents and financial details.</p>
    <div className="form-grid">
      <label>First name *<input name="first_name" autoComplete="given-name" maxLength="80" required /></label>
      <label>Last name *<input name="last_name" autoComplete="family-name" maxLength="80" required /></label>
      <label>Email *<input name="email" type="email" autoComplete="email" maxLength="254" required /></label>
      <label>Phone<input name="phone_number" type="tel" autoComplete="tel" maxLength="40" /></label>
    </div>
    <label>Subject *<input name="subject" defaultValue={params.get('project') ? `Enquiry: ${params.get('project').slice(0, 160)}` : ''} maxLength="200" required /></label>
    <label>Project details *<textarea name="message" rows="6" maxLength="5000" required placeholder="Project type, general location, scope and preferred timing" /></label>
    <div className="honeypot" aria-hidden="true"><label>Website<input name="website" tabIndex="-1" autoComplete="off" /></label></div>
    <label className="checkbox"><input type="checkbox" required name="consent" /> <span>I have read the <Link to="/privacy">privacy notice</Link> and agree to be contacted about this enquiry. *</span></label>
    <button className="button" disabled={status === 'sending'} type="submit">{status === 'sending' ? 'Sending…' : 'Send enquiry'} <span aria-hidden="true">↗</span></button>
    <div aria-live="polite" aria-atomic="true">{status === 'success' && <p className="notice success" role="status">Your enquiry was accepted for delivery. Thank you for contacting Anbelat.</p>}{status === 'error' && <p className="notice" role="alert">{error}</p>}</div>
    <p className="small">Prefer email? <a href={`mailto:${company.email}`}>{company.email}</a></p>
    </fieldset>
  </form>;
}
